import { Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import { isAbsoluteUrl } from "../services/urlService";
import style from "./NormalizedLink.module.css";

interface NormalizedLinkPropsDI {
  link: string | null;
  isNewTab?: boolean;
  [index: string]: any;
}

const NormalizedLink: React.FC<NormalizedLinkPropsDI> = (props) => {
  const l = props.link || "/";
  if (isAbsoluteUrl(l)) {
    return (
      <a
        className={`nav-link ${props.className}`}
        target={props.isNewTab ? "_blank" : ""}
        href={l.charAt(0) !== "h" ? `https://${l}` : l}
      >
        {props.children}{" "}
      </a>
    );
  }
  return (
    <Nav.Link
          as={Link}
          bsPrefix='nav-link'
      className={`${props.className ? props.className : ""} `}
      target={props.isNewTab ? "_blank" : ""}
      to={l}
      onClick={() => {
        if (props.onLinkClick) {
          props.onLinkClick();
        }
      }}
    >
      {props.children}
    </Nav.Link>
  );
};

export default NormalizedLink;
